import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useI18nContext } from "@hopper-b2b/i18n";
import { HotelsShopSelectors } from "../../../store";

export const useRoomSelectionPageContainer = ({
  goToNextStep,
}: {
  goToNextStep: () => void;
}) => {
  const { t } = useI18nContext();
  const rooms = useSelector(HotelsShopSelectors.getRooms);

  return useMemo(() => {
    return {
      context: { isError: rooms.isError, isLoading: rooms.isLoading },
      handlers: {
        goToNextStep,
      },
      text: {
        title: t("core-hotels.roomSelection.title"),
      },
    };
  }, [goToNextStep, rooms.isError, rooms.isLoading, t]);
};
